export function formatDateForInput(date: Date = new Date()): string {
  const tzOffsetInMs = date.getTimezoneOffset() * 60 * 1000;
  const localDate = new Date(date.getTime() - tzOffsetInMs);
  return localDate.toISOString().split('T')[0];
}


